import { useState } from "react";
import AnimateHeight from "react-animate-height";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { ReactComponent as IconBooking } from "../../assets/icons/ic_booking.svg";
import { ReactComponent as IconBranch } from "../../assets/icons/ic_branch.svg";
import { ReactComponent as IconGame } from "../../assets/icons/ic_game.svg";
import { STRING_MENU, STRING_SUB_MENU } from "../../constants/string";
import { MODULE_ROUTE } from "../../routers/module-router";
import { IRootState } from "../../store";
import { toggleSidebar } from "../../store/themeConfigSlice";
import IconCaretDown from "../icons/icon-caret-down";
import IconCaretsDown from "../icons/icon-carets-down";

const Sidebar = () => {
  const [currentMenu, setCurrentMenu] = useState<string>("");
  const semidry = useSelector((state: IRootState) => state.themeConfig.semidark);
  const dispatch = useDispatch();
  const toggleMenu = (value: string) => {
    console.log("value", value);
    setCurrentMenu((oldValue) => {
      return oldValue === value ? "" : value;
    });
  };

  return (
    <div className={semidry ? "dark" : ""}>
      <nav
        className={`sidebar fixed min-h-screen h-full top-0 bottom-0 w-[260px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] z-50 transition-all duration-300 ${
          semidry ? "text-white-dark" : ""
        }`}
      >
        <div className="h-full bg-white dark:bg-black">
          <div className="flex items-center justify-between px-4 py-3">
            <NavLink to={MODULE_ROUTE.COMPANIES} className="flex items-center main-logo shrink-0">
              {/* <img className="w-8 ml-[5px] flex-none" src="/assets/images/logo.svg" alt="logo" /> */}
              <span className="text-2xl ltr:ml-1.5 rtl:mr-1.5 font-semibold align-middle lg:inline dark:text-white-light">
                {"SCYBER"}
              </span>
            </NavLink>

            <button
              type="button"
              className="flex items-center w-8 h-8 transition duration-300 rounded-full collapse-icon hover:bg-gray-500/10 dark:hover:bg-dark-light/10 dark:text-white-light rtl:rotate-180"
              onClick={() => dispatch(toggleSidebar())}
            >
              <IconCaretsDown className="m-auto rotate-90" />
            </button>
          </div>
          <PerfectScrollbar className="h-[calc(100vh-80px)] relative">
            <ul className="relative font-semibold space-y-0.5 p-4 py-0">
              {/* <li className="nav-item">
                <NavLink to="/" className="w-full nav-link group" onClick={() => toggleMenu(STRING_MENU.DASHBOARD)}>
                  <div className="flex items-center">
                    <IconDashboard
                      className={`icon-svg ${
                        currentMenu === STRING_MENU.DASHBOARD
                          ? "shrink-0 fill-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:fill-orange-500 dark:group-hover:fill-white-dark" // Màu khi không active và hover
                      } dark:text-[#506690] dark:group-hover:text-white-dark`}
                    />
                    <span
                      className={`ltr:pl-3 rtl:pr-3 ${
                        currentMenu === STRING_MENU.DASHBOARD
                          ? "group-active:text-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:text-orange-500 " // Màu khi không active và hover
                      } dark:text-[#C5C6C9] dark:group-hover:text-white-dark uppercase`}
                    >
                      {STRING_MENU.DASHBOARD}
                    </span>
                  </div>
                </NavLink>
              </li> */}
              <li className="nav-item">
                <NavLink
                  to={MODULE_ROUTE.COMPANIES}
                  className="w-full nav-link group "
                  onClick={() => toggleMenu(STRING_MENU.MANAGEMENT_COMPANY)}
                >
                  <div className="flex items-center">
                    <IconBranch
                      className={`icon-svg ${
                        currentMenu === STRING_MENU.MANAGEMENT_COMPANY
                          ? "shrink-0 fill-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:fill-orange-500 dark:group-hover:fill-white-dark" // Màu khi không active và hover
                      } dark:text-[#506690] dark:group-hover:text-white-dark`}
                    />
                    <span
                      className={`ltr:pl-3 rtl:pr-3 ${
                        currentMenu === STRING_MENU.MANAGEMENT_COMPANY
                          ? "group-active:text-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:text-orange-500 " // Màu khi không active và hover
                      } dark:text-[#C5C6C9] dark:group-hover:text-white-dark`}
                    >
                      {STRING_MENU.MANAGEMENT_COMPANY}
                    </span>
                  </div>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to={MODULE_ROUTE.BRAND}
                  className="w-full nav-link group "
                  onClick={() => toggleMenu(STRING_MENU.MANAGEMENT_BRAND)}
                >
                  <div className="flex items-center">
                    <IconBranch
                      className={`icon-svg ${
                        currentMenu === STRING_MENU.MANAGEMENT_BRAND
                          ? "shrink-0 fill-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:fill-orange-500 dark:group-hover:fill-white-dark" // Màu khi không active và hover
                      } dark:text-[#506690] dark:group-hover:text-white-dark`}
                    />
                    <span
                      className={`ltr:pl-3 rtl:pr-3 ${
                        currentMenu === STRING_MENU.MANAGEMENT_BRAND
                          ? "group-active:text-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:text-orange-500 " // Màu khi không active và hover
                      } dark:text-[#C5C6C9] dark:group-hover:text-white-dark`}
                    >
                      {STRING_MENU.MANAGEMENT_BRAND}
                    </span>
                  </div>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to={MODULE_ROUTE.ADMIN}
                  className="w-full nav-link group "
                  onClick={() => toggleMenu(STRING_MENU.ADMIN)}
                >
                  <div className="flex items-center">
                    <IconBranch
                      className={`icon-svg ${
                        currentMenu === STRING_MENU.ADMIN
                          ? "shrink-0 fill-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:fill-orange-500 dark:group-hover:fill-white-dark" // Màu khi không active và hover
                      } dark:text-[#506690] dark:group-hover:text-white-dark`}
                    />
                    <span
                      className={`ltr:pl-3 rtl:pr-3 ${
                        currentMenu === STRING_MENU.ADMIN
                          ? "group-active:text-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:text-orange-500 " // Màu khi không active và hover
                      } dark:text-[#C5C6C9] dark:group-hover:text-white-dark`}
                    >
                      {STRING_MENU.ADMIN}
                    </span>
                  </div>
                </NavLink>
              </li>

              <li className="menu nav-item">
                <button
                  type="button"
                  className={`${
                    currentMenu === STRING_MENU.MANAGEMENT_PROMOTION_CAMPAIGN ? "active" : ""
                  } nav-link group w-full`}
                  onClick={() => toggleMenu(STRING_MENU.MANAGEMENT_PROMOTION_CAMPAIGN)}
                >
                  <div className="flex items-center">
                    <IconGame
                      className={`icon-svg ${
                        currentMenu === STRING_MENU.MANAGEMENT_PROMOTION_CAMPAIGN
                          ? "shrink-0 fill-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:fill-orange-500 dark:group-hover:fill-white-dark" // Màu khi không active và hover
                      } dark:text-[#506690] dark:group-hover:text-white-dark`}
                    />
                    <span
                      className={`ltr:pl-3 rtl:pr-3 ${
                        currentMenu === STRING_MENU.MANAGEMENT_PROMOTION_CAMPAIGN
                          ? "group-active:text-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:text-orange-500" // Màu khi không active và hover
                      } dark:text-[#C5C6C9] dark:group-hover:text-white-dark uppercase`}
                    >
                      {STRING_MENU.MANAGEMENT_PROMOTION_CAMPAIGN}
                    </span>
                  </div>

                  <div
                    className={
                      currentMenu !== STRING_MENU.MANAGEMENT_PROMOTION_CAMPAIGN ? "rtl:rotate-90 -rotate-90" : ""
                    }
                  >
                    <IconCaretDown
                      className={
                        currentMenu === STRING_MENU.MANAGEMENT_PROMOTION_CAMPAIGN
                          ? "fill-orange-500 dark:group-hover:fill-white-dark"
                          : "fill-gray-500 group-hover:fill-orange-500 "
                      }
                    />
                  </div>
                </button>

                <AnimateHeight
                  duration={300}
                  height={currentMenu === STRING_MENU.MANAGEMENT_PROMOTION_CAMPAIGN ? "auto" : 0}
                >
                  <ul className="text-gray-500 sub-menu">
                    <li>
                      <NavLink to={MODULE_ROUTE.PROMOTION_CAMPAIGN_TYPE}>
                        {STRING_SUB_MENU.PROMOTION_CAMPAIGN_TYPE}
                      </NavLink>
                    </li>

                    <li>
                      <NavLink to={MODULE_ROUTE.BRAND_CAMPAIGNS}>{STRING_SUB_MENU.BRAND_CAMPAIGNS}</NavLink>
                    </li>

                    <li>
                      <NavLink to={MODULE_ROUTE.PROMOTION_ASSIGN_BRAND}>
                        {STRING_SUB_MENU.BRAND_ASSIGN_PROMOTION}
                      </NavLink>
                    </li>
                  </ul>
                </AnimateHeight>
              </li>
              {/* Banner */}
              <li className="nav-item">
                <NavLink
                  to={MODULE_ROUTE.BANNER_PAGE}
                  className="w-full nav-link group"
                  onClick={() => toggleMenu(STRING_MENU.MANAGEMENT_BANNER)}
                >
                  <div className="flex items-center">
                    <IconBooking
                      className={`icon-svg ${
                        currentMenu === STRING_MENU.MANAGEMENT_BANNER
                          ? "shrink-0 fill-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:fill-orange-500 dark:group-hover:fill-white-dark" // Màu khi không active và hover
                      } dark:text-[#506690] dark:group-hover:text-white-dark`}
                    />
                    <span
                      className={`ltr:pl-3 rtl:pr-3 ${
                        currentMenu === STRING_MENU.MANAGEMENT_BANNER
                          ? "group-active:text-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:text-orange-500 " // Màu khi không active và hover
                      } dark:text-[#C5C6C9] dark:group-hover:text-white-dark uppercase`}
                    >
                      {STRING_MENU.MANAGEMENT_BANNER}
                    </span>
                  </div>
                </NavLink>
              </li>
              {/* App version */}
              <li className="nav-item">
                <NavLink
                  to={MODULE_ROUTE.APP_VERSION}
                  className="w-full nav-link group"
                  onClick={() => toggleMenu(STRING_MENU.MANAGEMENT_APP_VERSION)}
                >
                  <div className="flex items-center">
                    <IconBooking
                      className={`icon-svg ${
                        currentMenu === STRING_MENU.MANAGEMENT_APP_VERSION
                          ? "shrink-0 fill-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:fill-orange-500 dark:group-hover:fill-white-dark" // Màu khi không active và hover
                      } dark:text-[#506690] dark:group-hover:text-white-dark`}
                    />
                    <span
                      className={`ltr:pl-3 rtl:pr-3 ${
                        currentMenu === STRING_MENU.MANAGEMENT_APP_VERSION
                          ? "group-active:text-orange-500" // Màu khi active
                          : "text-gray-500 group-hover:text-orange-500 " // Màu khi không active và hover
                      } dark:text-[#C5C6C9] dark:group-hover:text-white-dark uppercase`}
                    >
                      {STRING_MENU.MANAGEMENT_APP_VERSION}
                    </span>
                  </div>
                </NavLink>
              </li>
            </ul>
          </PerfectScrollbar>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
